<template>
  <div class="advertising-pricing">
    <!-- Page Header -->
    <header class="header">
      <h1>Advertising Pricing</h1>
      <p>
        Choose the perfect advertising package to showcase your ski products to our engaged community of slalom skiers.
      </p>
    </header>

    <!-- Pricing Packages Section -->
    <section class="pricing-packages">
      <h2>Select Your Package</h2>
      <div class="packages-container">
        <div class="package">
          <div class="package-header">
            <h3>One Month</h3>
            <div class="price">$500</div>
          </div>
          <div class="package-features">
            <p>Perfect for seasonal promotions or new product launches</p>
            <ul>
              <li>30 days of exposure</li>
              <li>Ads are shown every 5th post in timeline</li>
              <li>Visible to all active skiers</li>
              <li>Performance analytics included</li>
            </ul>
          </div>
          <a href="/contact">
            <button class="select-button">Get Started</button>
          </a>
        </div>

        <div class="package featured">
          <div class="package-header">
            <h3>Three Months</h3>
            <div class="price">$1,200</div>
            <div class="savings">Save $300</div>
          </div>
          <div class="package-features">
            <p>Ideal for extended campaigns and seasonal coverage</p>
            <ul>
              <li>90 days of exposure</li>
              <li>Ads are shown every 5th post in timeline</li>
              <li>Visible to all active skiers</li>
              <li>Performance analytics included</li>
            </ul>
          </div>
          <a href="/contact">
            <button class="select-button">Get Started</button>
          </a>
        </div>

        <div class="package">
          <div class="package-header">
            <h3>Full Year</h3>
            <div class="price">$4,000</div>
            <div class="savings">Save $2,000</div>
          </div>
          <div class="package-features">
            <p>Maximum exposure for year-round brand presence</p>
            <ul>
              <li>365 days of exposure</li>
              <li>Ads are shown every 5th post in timeline</li>
              <li>Visible to all active skiers</li>
              <li>Performance analytics included</li>
              <li>Priority placement</li>
            </ul>
          </div>
          <a href="/contact">
            <button class="select-button">Get Started</button>
          </a>
        </div>
      </div>
    </section>

    <!-- Ad Visibility Section -->
    <section class="ad-visibility">
      <div class="visibility-container">
        <div class="visibility-text">
          <h2>Maximum Visibility</h2>
          <p>
            Your ads are strategically placed every 5th post in the home timeline, ensuring optimal visibility without overwhelming the user experience.
          </p>
          <p>
            With our active community of passionate slalom skiers, your products reach an engaged audience that's already interested in ski-related equipment and services.
          </p>
        </div>
        <img
          :src="require('@/assets/ad.png')"
          alt="Ad visibility example"
          class="visibility-image"
        />
      </div>
    </section>
  </div>

  <div class="advertising-pricing">
    <!-- Contact Us Section -->
    <section class="contact-us">
      <h2>Ready to Advertise?</h2>
      <p>
        Contact our team to discuss your advertising needs and get your ski products in front of our community.
      </p>
      <a href="/contact">
        <button class="contact-button">Contact Us</button>
      </a>
    </section>
  </div>

  <FooterPublic />
</template>

<script>
import FooterPublic from "@/components/FooterPublic.vue";
export default {
  name: "AdvertisingPricing",
  components: {
    FooterPublic,
  },
  methods: {
    navigateToContact() {
      this.$router.push("/contact");
    },
  },
};
</script>

<style scoped>
.advertising-pricing {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  color: #d9d9d9;
  background-color: #192734;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 12px;
}

.header {
  text-align: center;
  margin-bottom: 40px;
}

.header h1 {
  font-size: 2.5em;
  color: #ffffff;
  margin-bottom: 10px;
}

.header p {
  font-size: 1.2em;
  color: #ffffff;
}

.pricing-packages {
  margin-bottom: 40px;
}

.pricing-packages h2 {
  font-size: 2em;
  color: #ffffff;
  margin-bottom: 20px;
  text-align: center;
}

.packages-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

@media screen and (min-width: 768px) {
  .packages-container {
    flex-direction: row;
    justify-content: space-between;
  }
}

.package {
  background-color: #22303c;
  border-radius: 12px;
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}

.package:hover {
  transform: translateY(-5px);
}

.package.featured {
  border: 2px solid #1da1f2;
  position: relative;
}

.package-header {
  text-align: center;
  margin-bottom: 20px;
}

.package-header h3 {
  font-size: 1.5em;
  color: #ffffff;
  margin-bottom: 10px;
}

.price {
  font-size: 2em;
  font-weight: bold;
  color: #1da1f2;
}

.savings {
  color: #1da1f2;
  font-weight: bold;
  margin-top: 5px;
}

.package-features {
  margin-bottom: 20px;
  flex-grow: 1;
}

.package-features p {
  margin-bottom: 15px;
  color: #ffffff;
}

.package-features ul {
  list-style-type: none;
  padding-left: 0;
}

.package-features li {
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}

.package-features li:before {
  content: "✓";
  color: #1da1f2;
  position: absolute;
  left: 0;
}

.select-button {
  padding: 10px 20px;
  background-color: #1da1f2;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 1em;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
}

.select-button:hover {
  background-color: #0c8ddb;
}

.ad-visibility {
  margin-bottom: 40px;
}

.visibility-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

@media screen and (min-width: 768px) {
  .visibility-container {
    flex-direction: row;
    align-items: center;
  }
}

.visibility-text {
  flex: 1;
}

.visibility-text h2 {
  font-size: 1.8em;
  color: #ffffff;
  margin-bottom: 15px;
}

.visibility-text p {
  margin-bottom: 15px;
  color: #ffffff;
}

.visibility-image {
  width: 100%;
  max-width: 300px;
  border-radius: 12px;
}

.contact-us {
  text-align: center;
  margin-bottom: 40px;
}

.contact-us h2 {
  font-size: 2em;
  color: #ffffff;
  margin-bottom: 10px;
}

.contact-us p {
  font-size: 1.2em;
  color: #ffffff;
  margin-bottom: 20px;
}

.contact-button {
  padding: 10px 20px;
  background-color: #1da1f2;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 1em;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.contact-button:hover {
  background-color: #0c8ddb;
}
</style> 